import React, { useState } from "react";
import { FaCheckCircle, FaShoppingCart } from "react-icons/fa";
import "./TallyFieldPage.css";
import "./plans.css";
import TallyPrimePlan from './TallyPrimePlan'; 
import { useNavigate } from "react-router-dom";

const PricingCard = ({ title, features }) => {
  const navigate = useNavigate();

  const handleBuyNowClick = () => {
    navigate("/contact");
  };

  return (
    <div className="pricing-card-item premium-card">
      <div className="card-badge">{title === "GOLD" ? "Multi-User" : "Single User"}</div>
      <h3>{title}</h3>
      
      <div className="price-placeholder-wrapper">
        <p className="contact-for-price">Contact us for professional licensing & best quotes</p>
      </div>
      
      <ul className="feature-list">
        {features.map((feature, index) => (
          <li key={index}>
            <FaCheckCircle className="check-icon" /> {feature}
          </li>
        ))}
      </ul>

      <button className="buy-button" onClick={handleBuyNowClick}>
        Contact Us
      </button>
    </div>
  );
};

const PricingTable = () => {
  const plans = [
    {
      category: "TallyPrime Perpetual",
      options: [
        {
          title: "SILVER",
          features: [
            "Single user edition",
            "For Standalone PCs",
            "Perpetual license",
            "Zero cost EMI available",
          ],
        },
        {
          title: "GOLD",
          features: [
            "Unlimited multi-user edition",
            "For multiple PCs on LAN",
            "Perpetual license",
            "Zero cost EMI available",
          ],
        },
      ],
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Pricing Plans</span>
          <h1>Choose Your TallyPrime</h1>
          <p>Flexible licensing options designed to grow with your business.</p>
        </header>

        {plans.map((plan, pIdx) => (
          <div key={pIdx} className="pricing-category">
            <h2 className="category-title">{plan.category}</h2>
            <div className="pricing-grid">
              {plan.options.map((option, oIdx) => (
                <PricingCard key={oIdx} {...option} />
              ))}
            </div>
          </div>
        ))}

        <div className="rental-section-wrapper">
          <TallyPrimePlan />
        </div>
      </div>
    </div>
  );
};

export default PricingTable;
